import { render } from "./LoadingPlaceholder.3.vue?vue&type=template&id=5fa46067&ts=true"
import script from "./LoadingPlaceholder.3.vue?vue&type=script&lang=ts"
export * from "./LoadingPlaceholder.3.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__